import { queryFetch } from '@services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { foremanRoute, queryKeys } from '@utils/consts';
import { NoteReq, NoteRespSuccess } from './types';
import { useLocation } from 'react-router';
import { useJobRefetch } from '@hooks/job/refetch';

export const useRemoveNote = ({ callback }: { callback?: (data: NoteRespSuccess) => void }) => {
  const queryClient = useQueryClient();
  const { pathname } = useLocation();
  const { refetch, stages } = useJobRefetch();

  const { mutate, isPending } = useMutation({
    mutationFn: ({ id }: NoteReq): Promise<NoteRespSuccess> =>
      queryFetch({
        url: `notes/${id}`,
        opt: { method: 'DELETE' },
      }),
    onMutate: async ({ referableType, referableId, jobId }) =>
      stages.update({
        jobId,
        [referableType === 'Subtask' ? 'subtask' : 'task']: { id: referableId, note: undefined },
      }),
    onError: (err, { jobId }, prev) => {
      console.error(err);
      stages.restore(jobId, prev);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
      if (!pathname.includes(foremanRoute.questionnaires)) return;
      await queryClient.refetchQueries({ queryKey: queryKeys.questionnaire });
    },
    onSettled: (data) => {
      if (data && callback) callback(data);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
